var exports = {
  "wn": "Section__4O0N1z",
  "EY": "Text__8FKsqu",
  "Ec": "Control__HYjbOL",
  "Gb": "Feedback__oq6W4h",
};

module.exports = exports;
